import { render, staticRenderFns } from "./DoctorPosterProduction.vue?vue&type=template&id=5d668ea2&scoped=true&"
import script from "./DoctorPosterProduction.vue?vue&type=script&lang=js&"
export * from "./DoctorPosterProduction.vue?vue&type=script&lang=js&"
import style0 from "./DoctorPosterProduction.vue?vue&type=style&index=0&id=5d668ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d668ea2",
  null
  
)

export default component.exports